"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/message/v1/cms_service.proto (package spwn.message.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSMessageService = void 0;
const cms_service_pb_1 = require("./cms_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.message.v1.CMSMessageService
 */
exports.CMSMessageService = {
    typeName: "spwn.message.v1.CMSMessageService",
    methods: {
        /**
         * クリエイターが複数のファンにDMを一斉送信
         *
         * @generated from rpc spwn.message.v1.CMSMessageService.PostDMMessagesToCoreFansFromCreator
         */
        postDMMessagesToCoreFansFromCreator: {
            name: "PostDMMessagesToCoreFansFromCreator",
            I: cms_service_pb_1.CMSMessageServicePostDMMessagesToCoreFansFromCreatorRequest,
            O: cms_service_pb_1.CMSMessageServicePostDMMessagesToCoreFansFromCreatorResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * S3へのファイルアップロード用のpresigned urlをgetする
         *
         * @generated from rpc spwn.message.v1.CMSMessageService.GetSignedUrlForFileUpload
         */
        getSignedUrlForFileUpload: {
            name: "GetSignedUrlForFileUpload",
            I: cms_service_pb_1.CMSMessageServiceGetSignedUrlForFileUploadRequest,
            O: cms_service_pb_1.CMSMessageServiceGetSignedUrlForFileUploadResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * メッセージを受け取った時に、メール通知を受け取る設定を変更
         *
         * @generated from rpc spwn.message.v1.CMSMessageService.UpdateBrandDmNotificationSetting
         */
        updateBrandDmNotificationSetting: {
            name: "UpdateBrandDmNotificationSetting",
            I: cms_service_pb_1.CMSMessageServiceUpdateBrandDmNotificationSettingRequest,
            O: cms_service_pb_1.CMSMessageServiceUpdateBrandDmNotificationSettingResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * メッセージを受け取った時に、メール通知を受け取る設定を取得
         *
         * @generated from rpc spwn.message.v1.CMSMessageService.GetBrandDmNotificationSetting
         */
        getBrandDmNotificationSetting: {
            name: "GetBrandDmNotificationSetting",
            I: cms_service_pb_1.CMSMessageServiceGetBrandDmNotificationSettingRequest,
            O: cms_service_pb_1.CMSMessageServiceGetBrandDmNotificationSettingResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * まだメッセージを読めていないファンの数を取得
         *
         * @generated from rpc spwn.message.v1.CMSMessageService.GetNumberOfUnreadMessages
         */
        getNumberOfUnreadMessages: {
            name: "GetNumberOfUnreadMessages",
            I: cms_service_pb_1.CMSMessageServiceGetNumberOfUnreadMessagesRequest,
            O: cms_service_pb_1.CMSMessageServiceGetNumberOfUnreadMessagesResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=cms_service_connect.js.map